<template>
  <picker-field :label="label" :value="value" :is-focus="isFocus" title="选择仓库" ref="picker" @open="onSearch">
    <template v-slot:tbar>
      <search-bar
        @search="onSearch"
        @focus="onFocusChange"
        name="wh_code,wh_description"
        placeholder="请输入仓库编号或名称"
        ref="searchBar"
      />
    </template>
    <scroll-list @refresh="onSearch" @loadpage="onSearchNext">
      <div
        class="weui-cell weui-cell_access"
        v-for="item in items"
        :key="item.id"
        @click="select(item)"
      >
        <div class="weui-cell__bd">
          <p>
            {{item.wh_description}}
            <span
              class="list-item-status"
              v-if="item.wh_type"
            >{{item.wh_type}}</span>
          </p>
        </div>
        <div class="weui-cell__ft">
          <p>{{item.wh_code}}</p>
        </div>
      </div>
    </scroll-list>
  </picker-field>
</template>

<script>
import PickerField from "@/components/field/PickerField.vue";
import SearchBar from "@/components/SearchBar.vue";
import ScrollList from "@/components/ScrollList.vue";
import querylist from "@/mixins/querylist.js";

export default {
  components: {
    PickerField,
    SearchBar,
    ScrollList
  },
  mixins: [querylist],
  props: {
    label: {
      type: String,
      default: "仓库"
    },
    pr_kind: {
      type: String,
      default: ""
    },
    value: String
  },
  data() {
    return {
      isFocus: false,
      listUrl: "/api/document/warehouse/list",
      defaultCondition: { 
        type: "condition",
        value: "wh_statuscode='ENABLE'"
      }
    };
  },
  methods: {
    select(item) {
      var me = this;
      me.$emit("input", item.wh_description);
      me.$emit("select", item);
      me.$refs.picker.close();
    },
    onFocusChange(focus) {
      this.isFocus = focus;
    }
  },
  watch: {
    pr_kind(val) {
      if(val) {
        this.defaultCondition.value = `wh_statuscode='ENABLE' and wh_product_type = (select pt_pname from producttype  where producttype.companyid = warehouse.companyId and pt_name = '${this.pr_kind}')`
      } else {
        this.defaultCondition.value = "wh_statuscode='ENABLE'"
      }
    }
  }
};
</script>